import React from "react";
import { BrowserRouter as Router, Route, Routes, createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from "react-redux";
import routes from "./utils/routes";
import { store } from "./redux/store";
// import BackdropCircularProgressComponent from "./components/BackdropCircularProgressComponent";
// import ModalStrip from "./components/ModalStrip";
import BackdropCircularProgressComponent from "./components/BackdropCircularProgressComponent";
import ModalStrip from "./components/ModalStrip";
import Testing from "./components/Testing";
import Test2 from "./components/Test2";

const App = () => {
  const router = createBrowserRouter(routes);

  return (
    // <Provider store={store}>
    //   <BackdropCircularProgressComponent />
    //   <ModalStrip />
    //   <RouterProvider router={router} />
    // </Provider>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>

  );
};

export default App;
